module.exports = __webpack_public_path__ + "static/menuekarte-2cf20cf17fc6599a4740e6297ab11f7b.pdf";